export default "/images/vendor/flag-icon-css/flags/1x1/tn.svg?8b09464a7524dff3fa47e5a0204991e5";